import { Route } from '@angular/router';

import { FolderTabResolver } from './folders.resolvers';
import { FoldersTabComponent } from './folders.component';
import { FoldersTabFoldersListComponent } from './list/list.component';

export const foldersTabRoutes: Route[] = [
  {
    path: '',
    component: FoldersTabComponent,
    data: {
      module: 'FOLDERS_TAB',
    },
    children: [
      {
        path: '',
        component: FoldersTabFoldersListComponent,
        resolve: {
          folder: FolderTabResolver,
        },
      },
      {
        path: ':folderId',
        component: FoldersTabFoldersListComponent,
        resolve: {
          folder: FolderTabResolver,
        },
      },
    ],
  },
];
